import { Phone, X } from "lucide-react";

/**
 * 2-hour booking guardrail modal.
 * Pure presentation. Caller controls when it mounts.
 */
export default function DurationGuardModal({ open, onClose, message }) {
  if (!open) return null;
  const phoneE164 = "+13475230763";
  const phoneDisplay = "+1 (347) 523-0763";

  return (
    <div
      data-testid="duration-guard-modal"
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[300] flex items-center justify-center bg-black/90 backdrop-blur-md px-4 py-10"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative max-w-lg w-full backdrop-blur-xl bg-[#121214]/95 border border-[#C5A24A]/40 px-8 py-10 md:px-12 md:py-12 text-center"
      >
        <button
          type="button"
          onClick={onClose}
          data-testid="duration-guard-close"
          aria-label="Close"
          className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center border border-white/20 text-white hover:border-[#C5A24A] hover:text-[#C5A24A] transition-colors"
        >
          <X size={18} strokeWidth={1.5} />
        </button>

        <div className="text-[10px] uppercase tracking-[0.4em] text-[#C5A24A] mb-4">
          Custom Itinerary
        </div>
        <h2 className="font-serif text-3xl md:text-4xl text-white font-semibold tracking-tight leading-tight mb-5">
          Custom Itinerary Required
        </h2>
        <p className="text-sm md:text-base text-[#E6E6E6] font-light leading-relaxed mb-8 max-w-md mx-auto">
          {message || "Trips exceeding 2 hours require a custom itinerary structure and a manual operator quote. One of our chauffeurs will tailor your reservation directly."}
        </p>

        <a
          href={`tel:${phoneE164}`}
          data-testid="duration-guard-tel"
          className="w-full inline-flex items-center justify-center gap-3 bg-white text-black hover:bg-[#E6C46E] px-6 py-4 transition-all duration-300 font-medium text-sm tracking-[0.2em] uppercase"
        >
          <Phone size={16} strokeWidth={1.5} />
          Call {phoneDisplay}
        </a>

        <button
          type="button"
          onClick={onClose}
          data-testid="duration-guard-back"
          className="mt-4 w-full text-[11px] uppercase tracking-[0.3em] text-[#8E9AA6] hover:text-white py-2 transition-colors"
        >
          Adjust Trip Details
        </button>
      </div>
    </div>
  );
}
